
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import styles from './HelpSection.module.css';

const HelpSection = () => {
  const faqs = [
    {
      question: '¿Cómo me registro en Megaloto?',
      answer: 'Haz clic en "Regístrate" en el menú principal, completa tus datos y confirma tu cuenta.',
    },
    {
      question: '¿Es seguro jugar en Megaloto?',
      answer: 'Sí, contamos con certificados de seguridad y protección de datos en todas las transacciones.',
    },
    {
      question: '¿Cómo retiro mis ganancias?',
      answer: 'Puedes retirar tus ganancias directamente a tu cuenta bancaria o a través de métodos de pago admitidos.',
    },
    {
      question: '¿Qué sucede si tengo problemas?',
      answer: 'Puedes contactarnos por correo o chat en vivo 24/7 para recibir asistencia inmediata.',
    },
  ];
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        'service_p1cnd0i', // Reemplaza con tu Service ID
        'template_z5blldp', // Reemplaza con tu Template ID
        form,
        'wQFRPybWA_YoJ9_BU' // Reemplaza con tu User ID o API Key
      )
      .then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          setStatus('success');
          setForm({ name: '', email: '', message: '' });
        },
        (error) => {
          console.error('FAILED...', error);
          setStatus('error');
        }
      );
  };
  return (
    <section className={styles.helpSection} id="help">
      <h2>Ayuda y Soporte</h2>
      <div className={styles.content}>
        {/* FAQs Section */}
        <div className={styles.faqs}>
          <h3>Preguntas frecuentes</h3>
          {faqs.map((faq, index) => (
            <div key={index} className={styles.faq}>
              <h4>{faq.question}</h4>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className={styles.contact}>
          <h3>¿Aún tienes dudas?</h3>
          <p>Escríbenos a través de nuestro formulario o contáctanos por nuestros canales:</p>
          <ul>
            <li>Email: <a href="mailto:megaloto.2024@gmail.com">soporte@megaloto.com</a></li>
            <li>Teléfono: <a href="https://wa.me/573133956853?text=Estoy%20interesado%20en%20unirme%20al%20grupo%20de%20Megaloto,%20me%20das%20m%C3%A1s%20informacion,%20por%20favor">+57 313 395 6853</a></li>
            <li>Chat en vivo: Disponible 24/7</li>
          </ul>
          <form className={styles.form} onSubmit={handleSubmit}>
            <input 
                type="text"
                name="name"
                placeholder="Tu nombre"
                value={form.name}
                onChange={handleChange}
                required 
            />
            <input
              type="email"
              name="email"
              placeholder="Tu correo electrónico"
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Escribe tu mensaje"
              rows="4"
              value={form.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Enviar</button>
          </form>
          {status === 'success' && <p className={styles.success}>¡Mensaje enviado con éxito!</p>}
          {status === 'error' && <p className={styles.error}>Hubo un problema al enviar el mensaje. Inténtalo de nuevo.</p>}
        
        </div>
      </div>
    </section>
  );
};

export default HelpSection;
